import AxiosConfig from "config/axiosConfig";
import { IHttpStrongTypedResponse } from "model/IHttpResponse";
import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import UserTournamentActionType from "./actionType";

export const fetchUserTournamentAttendees = (nameOfLeague: string): ThunkAction<void, null, unknown, Action<string>> => async (dispatch) => {
    dispatch({ type: UserTournamentActionType.LOADING });
    try {
        const response: IHttpStrongTypedResponse<Number> = await AxiosConfig.get(`/leagues/attendees/${nameOfLeague}`);
        if (response.data.status !== 200) {
            return dispatch({ type: UserTournamentActionType.ERROR })
        }
        return dispatch({ type: UserTournamentActionType.SUCCESS, payload: { attendees: response.data.data, nameOfLeague } });
    }
    catch (error) {
        return dispatch({ type: UserTournamentActionType.ERROR })
    }
}